export default {
    SET_USER: 'SET_USER',
    SET_AUTHENTICATED: 'SET_AUTHENTICATED',
    SET_ROLES: 'SET_ROLES',
    SET_PERMISSIONS: 'SET_PERMISSIONS',
    SET_NAV_ITEMS: 'SET_NAV_ITEMS'
};
